import React, { useState, useEffect, useLayoutEffect } from "react";
import PuffLoader from "react-spinners/PuffLoader";
import Header from "./Header";
import Footer from "./Footer";
import { ToggleDarkMode } from "../assets/js/darkmode";
import LoadingPage from "../MyComponents/LoadingLogo";
import ScrollToTop from "./ScrollToTop";
import WhatsApp from "./Whatsapp";


function Layout(props) {
  useLayoutEffect(() => {
    setTimeout(() => {
      ToggleDarkMode();
    }, 500);
  }, [props.body]);
  return (
    <>
      <ScrollToTop />
      <LoadingPage />
      <Header />
      <main>
        {props.body}
        <WhatsApp/>
      </main>
      <Footer />
    </>
  );
}

export default Layout;
